import ClientReducer from "./ClientReducer";
import MainReducer from "./MainReducer";
import ModalReducer from "./ModalReducer";
import ProfessionReducer from "./ProfessionReducer";
import SchoolReducer from "./SchoolReducer";
import SearchReducer from "./SearchReducer";
import { connectRouter } from "connected-react-router";
import history from "../../routes/history";

export default {
    client: ClientReducer,
    modal: ModalReducer,
    profession: ProfessionReducer,
    school: SchoolReducer,
    main: MainReducer,
    search: SearchReducer,
    router: connectRouter(history)
};
